// 本项目调用欣能汇接口
import cryptoJs from "crypto-js";
import axios from "axios";
import { Toast } from "vant";
import { apiBaseUrlForComplex } from "@/utils/common";

// DES加密
let DESKey = "QElSkYBDaGZWNbYr";
// 管理员账号的密码
let adminKey = "sinonwh!@#";
const encryptDes = (message) => {
  var keyHex = cryptoJs.enc.Utf8.parse(DESKey);
  var option = {
    mode: cryptoJs.mode.ECB,
    padding: cryptoJs.pad.Pkcs7
  };
  var encrypted = cryptoJs.DES.encrypt(message, keyHex, option);
  return encrypted.ciphertext.toString().toUpperCase();
};

const encryptDesForAdmin = (message) => {
  var keyHex = cryptoJs.enc.Utf8.parse(adminKey);
  var option = {
    mode: cryptoJs.mode.ECB,
    padding: cryptoJs.pad.Pkcs7
  };
  var encrypted = cryptoJs.DES.encrypt(message, keyHex, option);
  return encrypted.ciphertext.toString().toUpperCase();
};

// 创建axios实例
const serviceXnh = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: apiBaseUrlForComplex,
  // 超时
  timeout: 60000,
  xhrFields: {
    withCredentials: false
  },
  crossDomain: true,
  emulateJSON: true
});

// request拦截器
serviceXnh.interceptors.request.use(config => {
  // 判断当前是否是管理员账号登录
  if (config.isAdmin == true) {
  // 参数加密
    let encryptParam = {
      param: encryptDesForAdmin(JSON.stringify({
        parampd: config.params || "",
        producttype: "ring"
      })),
      login_name: "xnh"
    };
    config.params = encryptParam;
  } else {
  // 参数加密
    let encryptParam = {
      param: encryptDes(JSON.stringify({
        parampd: config.params || "",
        producttype: "ring"
      })),
      login_name: "xnhsmallpro"
    };
    config.params = encryptParam;
  }
  return config;
},
error => {
  console.log("request error:" + error);
});

// 响应拦截器
serviceXnh.interceptors.response.use(function(response) {
  var data = response.data;
  if (!data) {
    Toast("返回数据异常");
  }
  if (data) {
    return data;
  }
},
function(error) {
  console.log("response error:" + error);
}
);

export default serviceXnh;



// WEBPACK FOOTER //
// ./src/utils/requestForComplex.js